<template>
  <v-snackbar
    v-model="visible"
    style="z-index:200;"
    :timeout="2000"
    :color="color"
    elevation="24"
    bottom
    right
    app
    content-class="the-toast-content"
    :vertical="isVertical"
    data-testid="toast"
    :data-state="visible ? 'open' : 'closed'"
    :data-toast-type="color"
  >
    <span data-testid="toast-message">{{ message }}</span>
    <v-container
      v-if="isVertical"
    >
      <v-row
        v-for="text in stackingContent"
        :key="text"
        data-testid="toast-stacked-message"
      >
        {{ text }}
      </v-row>
    </v-container>
  </v-snackbar>
</template>

<script>
import { EventBus } from '../util/EventBus'

export default {
  name: 'TheToast',

  data() {
    return {
       message: 'default message',
       color: 'success',
       visible: false,
       stackingContent: null,
    }
  },
  computed: {
    isVertical() {
      return this.stackingContent !== null
    },
  },
  mounted() {
    EventBus.$on('showtoast', this.showToastMessage)
  },
  methods: {
    showToastMessage(newValue) {      
      this.message = newValue.message
      this.color = newValue.type
      this.visible = true
      this.stackingContent = newValue?.stackingContent ?? null
    }
  },
}
</script>

<style>
/* Targets the Vuetify snackbar internals, so it can't be scoped. */
.the-toast-content {
  font-size: 1.125rem;
  line-height: 1.5;
  min-width: 360px;
  padding: 20px 24px;
}
</style>


